export type StatusTone = "待证实" | "进展中" | "已回应" | "实锤";

export interface NewsItem {
  id: number;
  category: string;
  status: StatusTone;
  title: string;
  summary: string;
  time: string;
  reads: string;
  likes: string;
  image: string;
}

export const categories = [
  "全部",
  "明星娱乐",
  "综艺饭圈",
  "影视剧综",
  "体育电竞",
  "职场圈",
];

export const breakingHeadlines = [
  "某新晋导演新作被曝换角内幕，圈内多方说法不一，事件仍在发酵",
  "顶流组合解散传闻再起，官方暂未回应，知情人士透露正在协调档期",
  "一档爆款综艺被指剪辑存争议，节目组回应将重新核对素材",
  "电竞俱乐部选手转会现反转，粉丝群凌晨炸开锅，当事人已发动态",
  "热播剧集疑有番位争议，片方晒出合同细节，网友评论两极分化",
];

export const newsList: NewsItem[] = [
  {
    id: 1,
    category: "明星娱乐",
    status: "进展中",
    title: "某当红歌手被曝舞台后台起争执，同场工作人员各执一词",
    summary:
      "据多位在场者描述，争议源于返场走位与现场协调问题，相关说法尚未得到本人与经纪团队正式回应，事件仍在持续跟进。",
    time: "08-28 21:40",
    reads: "18.6w",
    likes: "3204",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20backstage%20stage%20with%20warm%20red%20curtain%20and%20spotlights%2C%20moody%20low-key%20lighting%2C%20abstract%20newspaper%20collage%20texture%20with%20typography%20fragments%2C%20cinematic%20magazine%20cover%20aesthetic%2C%20rich%20amber%20and%20crimson%20tones%2C%20no%20real%20people%20identifiable%2C%20high%20detail%2C%20atmospheric%20composition&width=800&height=520&seq=melon-news-01&orientation=landscape",
  },
  {
    id: 2,
    category: "影视剧综",
    status: "待证实",
    title: "热播网剧第二季选角名单疑流出，网传主演档期仍在敲定",
    summary:
      "一份疑似项目组选角备选名单在网络流传，片方尚未确认名单真实性，多名被提及演员方表示暂不回应网传信息。",
    time: "08-28 19:05",
    reads: "12.1w",
    likes: "1876",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20clapperboard%20and%20film%20reel%20with%20warm%20studio%20lighting%2C%20abstract%20collage%20of%20scripts%20and%20call%20sheets%2C%20magazine%20editorial%20aesthetic%2C%20deep%20charcoal%20with%20amber%20and%20soft%20red%20accents%2C%20no%20real%20faces%20shown%2C%20cinematic%20texture%2C%20artistic%20high-detail%20composition&width=800&height=520&seq=melon-news-02&orientation=landscape",
  },
  {
    id: 3,
    category: "综艺饭圈",
    status: "已回应",
    title: "选秀节目投票数据引争议，节目方晒出第三方审计结果",
    summary:
      "针对外界对投票公正性的质疑，节目官方公布第三方审计报告并作出说明，同时开放数据复核通道，争议热度正在回落。",
    time: "08-28 17:26",
    reads: "9.8w",
    likes: "1520",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20glowing%20voting%20numbers%20and%20barcodes%20on%20a%20warm%20dark%20background%2C%20abstract%20data%20audit%20concept%2C%20subtle%20red%20and%20amber%20highlights%2C%20magazine%20infographic%20collage%20aesthetic%2C%20no%20people%2C%20moody%20cinematic%20lighting%2C%20high%20detail%20artistic%20composition&width=800&height=520&seq=melon-news-03&orientation=landscape",
  },
  {
    id: 4,
    category: "体育电竞",
    status: "待证实",
    title: "电竞战队转会期曝出重磅人选，圈内多个直播间同时提及",
    summary:
      "多位圈内解说在直播中先后提到同一人选并称“很快官宣”，俱乐部目前按兵不动，粉丝已在各平台开始自发讨论。",
    time: "08-28 15:12",
    reads: "7.4w",
    likes: "986",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20esports%20arena%20silhouettes%20with%20glowing%20red%20and%20amber%20neon%2C%20abstract%20transfer%20negotiation%20concept%20with%20jerseys%20and%20helmets%20in%20shadow%2C%20magazine%20collage%20aesthetic%2C%20dark%20background%20with%20warm%20accents%2C%20no%20readable%20faces%2C%20cinematic%20high-detail%20composition&width=800&height=520&seq=melon-news-04&orientation=landscape",
  },
  {
    id: 5,
    category: "职场圈",
    status: "进展中",
    title: "头部MCN机构被曝内部管理变动，员工已收到沟通邮件",
    summary:
      "有自称该机构前员工的用户发文讲述部门调整经过，机构官方表示正与相关团队沟通安排，建议以正式公告为准。",
    time: "08-28 13:48",
    reads: "6.2w",
    likes: "743",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20an%20open%20office%20workspace%20at%20dusk%20with%20abstract%20silhouettes%20and%20email%20inbox%20motifs%2C%20warm%20amber%20light%20through%20windows%2C%20magazine%20infographic%20collage%2C%20muted%20charcoal%20and%20cream%20tones%2C%20no%20identifiable%20people%2C%20cinematic%20moody%20high-detail%20composition&width=800&height=520&seq=melon-news-05&orientation=landscape",
  },
  {
    id: 6,
    category: "明星娱乐",
    status: "实锤",
    title: "某影帝档期冲突得到官宣证实，片方已发布全新拍摄时间表",
    summary:
      "关于该演员是否参与项目的猜测有了定论，片方今日以官方公告确认档期安排并致谢影迷，相关话题讨论量迅速攀升。",
    time: "08-28 11:30",
    reads: "15.9w",
    likes: "2681",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20film%20slate%20and%20schedule%20board%20with%20confirmed%20checkmarks%2C%20warm%20spotlight%20glow%2C%20abstract%20clapper%20and%20calendar%20collage%2C%20magazine%20editorial%20aesthetic%2C%20deep%20ink%20background%20with%20crimson%20and%20gold%20accents%2C%20no%20faces%2C%20cinematic%20high-detail%20artistic%20composition&width=800&height=520&seq=melon-news-06&orientation=landscape",
  },
  {
    id: 7,
    category: "综艺饭圈",
    status: "待证实",
    title: "年度盛典阵容海报疑提前泄露，多家粉丝组织已开始应援",
    summary:
      "一张疑似晚会嘉宾名单的海报截图流传，主办方未予置评，但多个应援站已在筹备应援物料，消息真伪仍有待确认。",
    time: "08-28 09:15",
    reads: "8.9w",
    likes: "1205",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20glamorous%20award%20stage%20with%20silhouette%20spotlights%20and%20balloons%2C%20abstract%20program%20poster%20collage%2C%20warm%20amber%20and%20crimson%20stage%20lighting%2C%20magazine%20cover%20aesthetic%2C%20dark%20background%2C%20no%20recognizable%20faces%2C%20high-detail%20cinematic%20composition&width=800&height=520&seq=melon-news-07&orientation=landscape",
  },
  {
    id: 8,
    category: "影视剧综",
    status: "进展中",
    title: "老牌IP翻拍选角被嘲“货不对板”，制作方深夜发文回应",
    summary:
      "围绕经典IP翻拍的主角人选，讨论持续升温，制作方深夜发布长文说明选角考量并承诺公开更多试镜资料，评论依旧两极。",
    time: "08-27 22:40",
    reads: "11.3w",
    likes: "2044",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20vintage%20film%20projector%20casting%20light%20onto%20an%20abstract%20script%2C%20warm%20sepia%20and%20amber%20tone%2C%20magazine%20collage%20of%20classic%20cinema%20motifs%2C%20deep%20brown%20and%20cream%20palette%2C%20no%20real%20people%2C%20moody%20nostalgic%20cinematic%20high-detail%20composition&width=800&height=520&seq=melon-news-08&orientation=landscape",
  },
  {
    id: 9,
    category: "职场圈",
    status: "已回应",
    title: "某内容平台被指数据口径不一，官方说明口径并给出核对入口",
    summary:
      "针对创作者反馈的数据展示差异，平台官方作出统一口径说明，并开放数据核对与申诉入口，多名创作者表示已复核通过。",
    time: "08-27 20:18",
    reads: "5.6w",
    likes: "611",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20abstract%20data%20dashboards%20and%20charts%20in%20warm%20amber%20tones%20on%20a%20dark%20background%2C%20magnifier%20and%20checkmarks%20collage%2C%20magazine%20infographic%20aesthetic%2C%20cream%20and%20charcoal%20accents%2C%20no%20people%2C%20clean%20cinematic%20high-detail%20composition&width=800&height=520&seq=melon-news-09&orientation=landscape",
  },
];

export const featured = {
  kicker: "本期重磅 · 编辑部深度",
  title: "从“网传”到“实锤”，一场吃瓜的全流程观察",
  lead: "我们拆解了一条爆料从匿名投稿、多方求证、当事人回应到最终落地的完整链条，看看信息在不同环节是如何被放大、修正或推翻的。",
  image:
    "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20detective-style%20investigation%20board%20with%20torn%20newspaper%20clippings%20and%20threads%20linking%20events%2C%20warm%20red%20and%20amber%20lighting%2C%20dramatic%20shadows%2C%20magazine%20cover%20collage%20aesthetic%2C%20dark%20charcoal%20background%20with%20cream%20paper%20fragments%2C%20no%20real%20people%20or%20faces%2C%20cinematic%20high-detail%20artistic%20composition&width=1600&height=900&seq=melon-featured&orientation=landscape",
  points: [
    "匿名来源为何需要二次求证：一线记者如何处理无法核实的线索",
    "当事人回应的黄金时间：一次危机公关如何影响讨论走向",
    "“反转”常发生：当多方证据冲突时，读者该怎么看",
    "编辑部的底线：哪些信息我们坚持不扩散、不猜测",
  ],
};

export const timeline = [
  {
    time: "10:20",
    category: "明星娱乐",
    tag: "首发",
    text: "某剧组官微突然更新置顶公告，外界猜测与选角调整有关，讨论量开始攀升。",
    heat: "1.2w",
  },
  {
    time: "12:05",
    category: "综艺饭圈",
    tag: "跟进",
    text: "疑似节目组内部会议纪要片段在多个聊天群流传，真实性暂未确认，平台已标注来源待核实。",
    heat: "3.4w",
  },
  {
    time: "14:30",
    category: "职场圈",
    tag: "回应",
    text: "涉事公司发布声明，表示部分细节与事实不符，并公布对外沟通邮箱欢迎核对。",
    heat: "5.1w",
  },
  {
    time: "17:45",
    category: "体育电竞",
    tag: "反转",
    text: "此前流传的转会名单出现新版本，多位解说改口称“以官宣为准”，剧情再度反转。",
    heat: "7.8w",
  },
  {
    time: "21:00",
    category: "影视剧综",
    tag: "实锤",
    text: "片方正式公布全新演员阵容与拍摄安排，持续一天的猜测告一段落，官方信息成为唯一口径。",
    heat: "10.6w",
  },
];

export const faqs = [
  {
    q: "你们的内容来源是什么？",
    a: "平台内容主要来自匿名投稿、公开信息检索与多方转载线索。所有进入页面的内容都会标注核实状态（待证实 / 进展中 / 已回应 / 实锤），无法确认的信息会明确提示，请以官方最终口径为准。",
  },
  {
    q: "投稿后会立刻发布吗？",
    a: "不会。我们会先对投稿进行真实性初筛，尽量通过公开信息或多方交叉比对验证。对于暂时无法核实的爆料，我们会标注来源待核实，也会剔除明显造谣、涉及隐私或带有人身攻击的内容。",
  },
  {
    q: "我发的爆料会不会被公开我的信息？",
    a: "我们坚持匿名原则，投稿系统不强制要求填写真实姓名与联系方式，默认也不会公开展示任何可识别身份的投稿人信息。请勿在描述中包含他人真实隐私信息。",
  },
  {
    q: "如何区分“网传”与“实锤”？",
    a: "我们为每条内容标注了四种状态：仅凭单方面说法且未获证实的为“待证实”；正在跟进多方求证或出现新进展的为“进展中”；涉事方作出说明的为“已回应”；有官方公告、合同文件或当事人亲口确认等可靠证据的才标注“实锤”。",
  },
  {
    q: "看到不实信息或想删除相关稿件怎么办？",
    a: "如果你认为某条内容存在事实错误，或涉及你本人的不实描述，可通过投稿入口选择“纠错 / 申诉”，并提供必要说明。核实后我们会尽快补充更正说明或按要求处理相关内容。",
  },
  {
    q: "平台如何避免传播谣言？",
    a: "我们把“不造谣、不传谣、尊重当事人”作为底线：无法核实的采用克制表述，不做主观定罪，不为流量放大未经证实的指控。涉及未成年人、隐私与严肃法律的题材会被严格拦截。",
  },
];